// ProtectedRoute.jsx

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { canAccessPath } from "../config/roles";

function ProtectedRoute({ user, role, children }) {
  const location = useLocation();

  // 1. Пользователь не авторизован
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 2. Пользователь авторизован, но роль не определена
  if (!role) {
    return (
      <div className="h-screen w-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-2">
            Нет доступа
          </h1>

          <p className="text-gray-500">
            Для пользователя не назначена роль.
          </p>
        </div>
      </div>
    );
  }

  // Для отладки
  console.log("[AUTH]", {
    pathname: location.pathname,
    role: role.id,
    defaultPath: role.defaultPath,
    allowedPaths: role.modules?.map((module) => module.path),
  });

  // 3. Если пользователь находится на "/",
  // отправляем его на стартовую страницу его роли
  if (location.pathname === "/") {
    // Administrator starts on DesktopPage
    if (role.id === "admin") {
      return children;
    }

    // Other roles go to their configured start page
    return (
      <Navigate
        to={role.defaultPath}
        replace
      />
    );
  }

  // 4. Проверяем доступ текущей роли к текущему URL
  const allowed = canAccessPath(
    role,
    location.pathname
  );

  // 5. Если доступа нет —
  // отправляем пользователя на его defaultPath
  if (!allowed) {
    console.log(
      `[AUTH] Access denied: ${location.pathname} → ${role.defaultPath}`
    );

    return (
      <Navigate
        to={role.defaultPath}
        replace
      />
    );
  }

  // 6. Всё хорошо — показываем страницу
  return children;
}

export default ProtectedRoute;